var map = {
	"./apparat-active.png": 7725,
	"./apparat-inactive.png": 19120,
	"./ballywulff-active.png": 9024,
	"./ballywulff-inactive.png": 24809,
	"./edict-active.png": 31551,
	"./edict-inactive.png": 27886,
	"./gamomat-active.png": 10430,
	"./gamomat-inactive.png": 24587,
	"./hoelle-active.png": 36807,
	"./hoelle-inactive.png": 28534,
	"./microgaming-active.png": 75405,
	"./microgaming-inactive.png": 84880,
	"./netent-active.png": 53292,
	"./netent-inactive.png": 8637,
	"./onlyplay-active.png": 63592,
	"./onlyplay-inactive.png": 5553,
	"./playzia-active.png": 41350,
	"./playzia-inactive.png": 82291,
	"./spinomenal-active.png": 40774,
	"./spinomenal-inactive.png": 87347
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75947;